// Resolved state of the private split-invite page (§2). The hook derives exactly
// one of these from the authenticated GET (or an action), and the view switches
// on it. Unlike the mentoring invite, there is no logged-out branch — the route
// is private, so a real signed-in user always exists by the time we render.
//
//   loading      → still fetching the invite
//   valid        → a usable, pending/awaiting_wallet invite for THIS account →
//                  render the community + accept/decline area
//   accepted     → the visitor just accepted here → success confirmation
//   not_found    → 404: token doesn't exist          → "Convite não encontrado"
//   expired      → 422 / expires_at in the past       → "Convite expirado"
//   used         → 422 / already answered or revoked   → "Convite indisponível"
//   declined     → the visitor just declined here      → recusa confirmation
//   wrong_email  → signed in as a different account     → switch-account screen
//   error        → anything else (network/5xx)         → generic retry
export const SPLIT_INVITE_STATE = {
  LOADING: "loading",
  VALID: "valid",
  ACCEPTED: "accepted",
  NOT_FOUND: "not_found",
  EXPIRED: "expired",
  USED: "used",
  DECLINED: "declined",
  WRONG_EMAIL: "wrong_email",
  ERROR: "error",
};

// Terminal (non-actionable) states — the ones that render a centered status
// screen instead of the live invite card.
export const TERMINAL_SPLIT_INVITE_STATES = [
  SPLIT_INVITE_STATE.ACCEPTED,
  SPLIT_INVITE_STATE.NOT_FOUND,
  SPLIT_INVITE_STATE.EXPIRED,
  SPLIT_INVITE_STATE.USED,
  SPLIT_INVITE_STATE.DECLINED,
  SPLIT_INVITE_STATE.ERROR,
];
